export const blogText = {
  JP: {
    heroTitle: ["宮古島をもっと楽しむ", "島旅ガイド"],
    heroDescription:
      "カフェ、グルメ、絶景ドライブ、撮影におすすめの場所まで。厳選した情報のみを紹介します。",
    heroPopularButton: "おすすめ記事を見る",
    heroToursButton: "ツアーを見る",
    popularArticles: "人気の記事",
    categoryLabel: "CATEGORY",
    categoryTitle: "カテゴリから探す",
    tagLabel: "TAG",
    tagTitle: "#から探す",
    selectedCategory: "SELECTED CATEGORY",
    articleSuffix: "の記事",
    articlesCount: "articles",
    emptyText: "このカテゴリ・タグの記事はまだありません。",
    featuredLabel: "FEATURED",
    featuredTitle: "宮古島で車で行ける絶景スポット9選",
    featuredText:
      "宮古ブルーの海を見渡せる橋、白砂のビーチ、岬の絶景、そして夕日が綺麗に見えるサンセットスポットまで。車で回りやすい宮古島の絶景スポットをまとめました。",
    featuredButton: "この記事を読む",
    newArticles: "新着記事",
    ctaScript: "Movie for memories",
    ctaTitle: ["思い出を", "一生残る形に"],
    ctaText: "宮古島での特別な思い出を写真や映像で残します",
    ctaButton: "撮影付きツアーを見る",
    backToBlog: "ブログ一覧へ戻る",
    articleList: "記事一覧",
    archiveCategoryLabel: "CATEGORY ARTICLES",
    archiveTagLabel: "TAG ARTICLES",
    archiveEmptyTitle: "まだ記事がありません",
    archiveEmptyText: "このカテゴリ・タグの記事はまだ準備中です。",
    archiveTagDescription: "に関連する宮古島の記事をまとめました。",
    archiveCategoryDescription: "に関連するおすすめ記事をまとめました。",
    popularSideLabel: "POPULAR ARTICLES",
    sideCategoryTitle: "カテゴリから探す",
    sideTagTitle: "#タグ",
    defaultCtaTitle: "思い出を一生残る形に",
    defaultCtaText: "宮古島での特別な思い出を写真や映像で残します",
    defaultCtaButton: "撮影付きツアーを見る",
    readTimePrefix: "読了時間",
    share: "SHARE",
    tocTitle: "目次",
    tocImageAlt: "目次イメージ",
    instagramLoading: "Instagramを読み込み中",
    googleMapOpen: "Google Mapで開く",
    articlePhotoAlt: "写真",
    instagramPostAlt: "Instagram投稿",
    defaultYoutubeTitle: "動画で雰囲気を見る",
    defaultGuideInstagramTitle: "ガイドのInstagram",
    instagramButton: "Instagramを見る",
    defaultShareTitle: "宮古島ブログ",
    defaultShareText: "宮古島のおすすめ記事をシェア",
    miyakojimaTag: "#宮古島",
    tourImageAlt: "宮古島ツアー",
    websiteDetail: "詳細を見る",
  },
  EN: {
    heroTitle: ["Enjoy Miyakojima More", "Island Travel Guide"],
    heroDescription:
      "Carefully selected cafes, food, scenic drives, and photo spots around Miyakojima.",
    heroPopularButton: "View Recommended Articles",
    heroToursButton: "View Tours",
    popularArticles: "Popular Articles",
    categoryLabel: "CATEGORY",
    categoryTitle: "Browse by Category",
    tagLabel: "TAG",
    tagTitle: "Browse by #",
    selectedCategory: "SELECTED CATEGORY",
    articleSuffix: " Articles",
    articlesCount: "articles",
    emptyText: "No articles are available for this category or tag yet.",
    featuredLabel: "FEATURED",
    featuredTitle: "9 Scenic Spots You Can Visit by Car in Miyakojima",
    featuredText:
      "A guide to Miyakojima spots that are easy to visit by car, from bridges overlooking Miyako blue waters to white sand beaches, capes, and sunset views.",
    featuredButton: "Read Article",
    newArticles: "New Articles",
    ctaScript: "Movie for memories",
    ctaTitle: ["Keep Your Memories", "For a Lifetime"],
    ctaText: "Capture your special Miyakojima memories in photos and video.",
    ctaButton: "View Photo Tours",
    backToBlog: "Back to Blog",
    articleList: "Articles",
    archiveCategoryLabel: "CATEGORY ARTICLES",
    archiveTagLabel: "TAG ARTICLES",
    archiveEmptyTitle: "No articles yet",
    archiveEmptyText: "This category or tag is still being prepared.",
    archiveTagDescription: " related Miyakojima articles.",
    archiveCategoryDescription: " recommended articles.",
    popularSideLabel: "POPULAR ARTICLES",
    sideCategoryTitle: "Browse by Category",
    sideTagTitle: "#Tags",
    defaultCtaTitle: "Keep Your Memories For a Lifetime",
    defaultCtaText: "Capture your special Miyakojima memories in photos and video.",
    defaultCtaButton: "View Photo Tours",
    readTimePrefix: "Read time",
    share: "SHARE",
    tocTitle: "Contents",
    tocImageAlt: "contents image",
    instagramLoading: "Loading Instagram",
    googleMapOpen: "Open in Google Map",
    articlePhotoAlt: "Photo",
    instagramPostAlt: "Instagram post",
    defaultYoutubeTitle: "Watch the atmosphere in video",
    defaultGuideInstagramTitle: "Guide Instagram",
    instagramButton: "View Instagram",
    defaultShareTitle: "Miyakojima Blog",
    defaultShareText: "Share a recommended Miyakojima article",
    miyakojimaTag: "#Miyakojima",
    tourImageAlt: "Miyakojima tour",
    websiteDetail: "View details",
  },
  中文: {
    heroTitle: ["更深入享受宫古岛", "岛旅指南"],
    heroDescription: "精选宫古岛咖啡馆、美食、绝景自驾路线与适合拍照的地点。",
    heroPopularButton: "查看推荐文章",
    heroToursButton: "查看行程",
    popularArticles: "热门文章",
    categoryLabel: "CATEGORY",
    categoryTitle: "按分类查找",
    tagLabel: "TAG",
    tagTitle: "按#标签查找",
    selectedCategory: "SELECTED CATEGORY",
    articleSuffix: "相关文章",
    articlesCount: "articles",
    emptyText: "这个分类或标签的文章还在准备中。",
    featuredLabel: "FEATURED",
    featuredTitle: "宫古岛开车可到的9个绝景地点",
    featuredText:
      "从能眺望宫古蓝海的桥、白沙海滩、岬角绝景到夕阳景点，整理了适合自驾前往的宫古岛绝景。",
    featuredButton: "阅读文章",
    newArticles: "最新文章",
    ctaScript: "Movie for memories",
    ctaTitle: ["把回忆", "留成一生的影像"],
    ctaText: "用照片和视频留下在宫古岛的特别回忆。",
    ctaButton: "查看拍摄行程",
    backToBlog: "返回博客列表",
    articleList: "文章列表",
    archiveCategoryLabel: "CATEGORY ARTICLES",
    archiveTagLabel: "TAG ARTICLES",
    archiveEmptyTitle: "暂无文章",
    archiveEmptyText: "这个分类或标签的文章还在准备中。",
    archiveTagDescription: "相关的宫古岛文章。",
    archiveCategoryDescription: "相关的推荐文章。",
    popularSideLabel: "POPULAR ARTICLES",
    sideCategoryTitle: "按分类查找",
    sideTagTitle: "#标签",
    defaultCtaTitle: "把回忆留成一生的影像",
    defaultCtaText: "用照片和视频留下在宫古岛的特别回忆。",
    defaultCtaButton: "查看拍摄行程",
    readTimePrefix: "阅读时间",
    share: "SHARE",
    tocTitle: "目录",
    tocImageAlt: "目录图片",
    instagramLoading: "正在加载Instagram",
    googleMapOpen: "在Google Map中打开",
    articlePhotoAlt: "照片",
    instagramPostAlt: "Instagram帖子",
    defaultYoutubeTitle: "用视频感受氛围",
    defaultGuideInstagramTitle: "向导Instagram",
    instagramButton: "查看Instagram",
    defaultShareTitle: "宫古岛博客",
    defaultShareText: "分享宫古岛推荐文章",
    miyakojimaTag: "#宫古岛",
    tourImageAlt: "宫古岛行程",
    websiteDetail: "查看详情",
  },
  한국어: {
    heroTitle: ["미야코지마를 더 즐기는", "섬 여행 가이드"],
    heroDescription:
      "카페, 맛집, 절경 드라이브, 촬영하기 좋은 장소까지 엄선해 소개합니다.",
    heroPopularButton: "추천 글 보기",
    heroToursButton: "투어 보기",
    popularArticles: "인기 글",
    categoryLabel: "CATEGORY",
    categoryTitle: "카테고리로 찾기",
    tagLabel: "TAG",
    tagTitle: "#태그로 찾기",
    selectedCategory: "SELECTED CATEGORY",
    articleSuffix: " 글",
    articlesCount: "articles",
    emptyText: "이 카테고리 또는 태그의 글은 아직 없습니다.",
    featuredLabel: "FEATURED",
    featuredTitle: "미야코지마에서 차로 갈 수 있는 절경 스팟 9선",
    featuredText:
      "미야코 블루를 내려다보는 다리, 하얀 모래 해변, 곶의 절경, 석양 명소까지 차로 둘러보기 좋은 스팟을 정리했습니다.",
    featuredButton: "글 읽기",
    newArticles: "새 글",
    ctaScript: "Movie for memories",
    ctaTitle: ["추억을", "평생 남는 형태로"],
    ctaText: "미야코지마에서의 특별한 추억을 사진과 영상으로 남깁니다.",
    ctaButton: "촬영 투어 보기",
    backToBlog: "블로그 목록으로",
    articleList: "글 목록",
    archiveCategoryLabel: "CATEGORY ARTICLES",
    archiveTagLabel: "TAG ARTICLES",
    archiveEmptyTitle: "아직 글이 없습니다",
    archiveEmptyText: "이 카테고리 또는 태그의 글은 준비 중입니다.",
    archiveTagDescription: " 관련 미야코지마 글을 모았습니다.",
    archiveCategoryDescription: " 관련 추천 글을 모았습니다.",
    popularSideLabel: "POPULAR ARTICLES",
    sideCategoryTitle: "카테고리로 찾기",
    sideTagTitle: "#태그",
    defaultCtaTitle: "추억을 평생 남는 형태로",
    defaultCtaText: "미야코지마에서의 특별한 추억을 사진과 영상으로 남깁니다.",
    defaultCtaButton: "촬영 투어 보기",
    readTimePrefix: "읽는 시간",
    share: "SHARE",
    tocTitle: "목차",
    tocImageAlt: "목차 이미지",
    instagramLoading: "Instagram 불러오는 중",
    googleMapOpen: "Google Map에서 열기",
    articlePhotoAlt: "사진",
    instagramPostAlt: "Instagram 게시물",
    defaultYoutubeTitle: "영상으로 분위기 보기",
    defaultGuideInstagramTitle: "가이드 Instagram",
    instagramButton: "Instagram 보기",
    defaultShareTitle: "미야코지마 블로그",
    defaultShareText: "미야코지마 추천 글 공유",
    miyakojimaTag: "#미야코지마",
    tourImageAlt: "미야코지마 투어",
    websiteDetail: "자세히 보기",
  },
};
